import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost, apiPatch } from '../api/client.js';

export const useUsers = () =>
  useQuery({ queryKey: ['users'], queryFn: () => apiGet('/users') });

export const useCreateUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiPost('/users', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
};

export const useDisableUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiPatch(`/users/${id}/disable`, {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
};

export const useEnableUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiPatch(`/users/${id}/enable`, {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
};

export const useUpdateUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) => apiPatch(`/users/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
};

export const useChangeOwnPassword = () =>
  useMutation({
    mutationFn: ({ currentPassword, newPassword }) => apiPatch('/users/me/password', { currentPassword, newPassword }),
  });
